export default {
  noData: {
    summary: 'Keine Daten gefunden',
  },
  noAccess: 'Benutzer hat keinen Zugriff',
};
